import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import CustomModal from '../CustomModal'
import TextEditor from '../../../../TextEditor'
import { Input, ModalBody, ModalFooter } from 'reactstrap'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'

export default function AddText(props) {
  const dispatch = useDispatch()
  const onChange = (newContent) => {
    // let newContent = evt.editor.getData()
    props.onChangeNewText(newContent)
  }

  useEffect(() => {
    props.onChangeNewText('')
    props.onChangeTitleText('')

    return () => {
      props.onChangeNewText('')
    }
  }, [])

  let language = props.language || {}

  return (
    <CustomModal
      courseId={props.course_id}
      title={language.courses ? language.courses.add_text : null}
      size='lg'
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          props.addTextContainer()
          dispatch(invalidateCoursesOverview())
        }}
      >
        <ModalBody>
          <div className='px-0'>
            <div className='mb-2 px-0 col-6'>
              <Input
                type='text'
                name='title'
                placeholder={language?.settings?.title}
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>

          <TextEditor
            customStyle='px-2'
            textContent={props.newTextContent}
            onChangeText={onChange}
            setOptions={{
              buttonList: [
                [
                  'undo',
                  'redo',
                  'font',
                  'fontSize',
                  'formatBlock',
                  'list',
                  'align',
                  'fontColor',
                ],
                ['bold', 'underline', 'italic', 'horizontalRule'],
                ['codeView', 'outdent', 'indent'],
                ['table', 'image', 'link', 'video'],
              ],
            }}
          />
          <div className='custom-control custom-checkbox-info mt-2'>
            <input
              className='custom-control-input'
              id='required_content'
              type='checkbox'
              checked={props.requiredContent}
              onChange={props.setRequired}
            />
            <label
              className='custom-control-label '
              htmlFor='required_content'
              style={{ fontSize: '14px', paddingTop: '2px' }}
            >
              {language?.courses?.required}
            </label>
          </div>
        </ModalBody>
        <ModalFooter className='justify-content-start '>
          <SubmitModalButton text={language?.general?.submit} />
          <Link to={`/course/${props.course_id}/edit`}>
            <CancelModalButton text={language?.general?.cancel} />
          </Link>
        </ModalFooter>
      </form>
    </CustomModal>
  )
}
